export default function FondoConfirmar({ fondo }) {
    return <img src={`./imgs/${fondo.nombre}-color.png`} width="39" height="39" alt="" />
};